import { render, staticRenderFns } from "./indexDashboard.vue?vue&type=template&id=70e48914&"
import script from "./indexDashboard.vue?vue&type=script&lang=js&"
export * from "./indexDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports